import React, { useEffect, useRef, useState } from 'react';
import { GridColDef, GridRowId } from '@mui/x-data-grid';
import { AppBar, Box, Button, Checkbox, createTheme, FormControlLabel, FormGroup, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useApi } from '../../../services/HttpService';
import ScrollableDataGrid from '../../../components/tables/ScrollableDataGrid';
import { GridApiCommunity } from '@mui/x-data-grid/internals';
import BaseModal from '../../../components/modals/BaseModal';
import { StickyAlert } from '../../../components/ui/StickyAlert';
import { highlightedGridColumns } from '../../../components/tables/BaseTable';
import { EnhancedTableToolbar } from '../../../components/tables/AdminTable';
import HardDeleteDialog from '../../../components/modals/dialog/HardDeleteDialog';
import { AppDeviceOverview } from './AppDeviceOverview';
import {newAppDevice, AppDevice, AppBase, AppDeviceMessage, AppSetting, newAppSetting} from '../../../model/AppBase';
import  LeftSideMenu  from '../../../components/layouts/navigations/LeftSideMenu';

const mainColumns: GridColDef[] = [
    { field: 'location', headerName: 'Location', width: 200 },
    { field: 'content', headerName: 'Content', width: 200, type: 'boolean' },
    { field: 'links', headerName: 'Links', width: 200, type: 'boolean'  },
    { field: 'action', headerName: 'Action', width: 200 },
];

const testData = newAppSetting();

testData.action= "Test action";
testData.loaction= "Test location";

// let testArray: AppSetting[];
// testArray.fill(testData)


export const AppSettings = () => {
  const [AppDevices, setAppDevices] = useState<AppDevice[]>([]);
  const [tabIndex, setTabIndex] = useState(0);
  const theme = useTheme();
  const { api, isLoading, error } = useApi();
  const { api: deleteApi, isLoading: deleteIsLoading, error: deleteError } = useApi();
  const { api: dataApi, error: dataError } = useApi();
  const [AppDevice, setAppDevice] = useState<AppDevice>(newAppDevice());
  const [filteredAppDevices, setFilteredAppDevices] = useState<AppDevice[]>([]);
  const [searchText, setSearchText] = useState("");
  const [selectedIds, setSelectedIds] = useState<readonly GridRowId[]>([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEditAppDevice, setOpenEditAppDevice] = useState(false);
  const apiRef = useRef<GridApiCommunity>(null);
  const [appSettings, setAppSettings] = useState<AppSetting[]>([]);
  // const addMemberRef = useRef<MemberFormRef>(null);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  React.useEffect(() => {
    getData();
    // testArray.fill(testData)
    // setAppSettings(testArray)
  }, []);

  const onItemChange = (changedItem: AppDevice) => {
    setAppDevices((prevProfiles) => {
      const index = prevProfiles.findIndex(u => u.id === changedItem.id);
      if (index > -1) {
        return prevProfiles.map((user, i) => (i === index ? changedItem : user));
      } else {
        return [...prevProfiles, changedItem];
      }
    });

    setAppDevice(changedItem);
    setSelectedIds([changedItem.id]);
  }
  
  const getData = () => {
    // api("manage/app/getAppDevices", "POST").then((res) => {
    //   if (res?.statusCode === 200) {
    //     setAppDevices(res.data);
    //   }
    // });

    api("/manage/app/getAppDevices", "POST", { search: "", limit: 0 }).then((res) => {
        if (res?.statusCode === 200) {
          setAppDevices(res.data);
        }
    });
  }

  useEffect(() => {
    handleSearch(searchText);
  }, [AppDevices]);

  const handleSearch = (searchText: string) => {
    const query = searchText.toLowerCase();
    setSearchText(query);

    const filteredData = AppDevices ? AppDevices.filter((row) =>
      mainColumns.some((column) => {

        // Use valueGetter if defined, otherwise use the field directly
        const value = column.valueGetter
          ? column.valueGetter(undefined as never, row, column, apiRef)
          : row[column.field];

        return String(value).toLowerCase().includes(query);
      })
    ) : [];

    setFilteredAppDevices(filteredData);
  };

  const getPageAppDevices = (page: number, pageSize: number) => {
    if (AppDevices.length === 0) {
      return [];
    }
    const sublist = AppDevices.slice(page * pageSize, (page + 1) * pageSize);
    console.log("returning members from index", page * pageSize, "-", (page + 1) * pageSize, "count", sublist.length)
    return sublist;
  }

  const handleRowSelectionModelChange = (ids: number[]) => {
    setSelectedIds(ids);

    if (ids.length > 0) {
      let selectedAppDevice = AppDevices.find(u => u.id === ids[0]);
      setAppDevice(selectedAppDevice);
    } else {
      setAppDevice(newAppDevice());
    }
  }

  const handleRowDoubleClick = (row) => {
    let ids = [row.id];
    handleRowSelectionModelChange(ids);
    setOpenEditAppDevice(true);
  }

  const handleDelete = (hardDelete: boolean) => {
    alert("delete not implemented");
  }

  return (
    <>
    <Box sx={{ width:'100%' , display: 'flex' }} >
       {/* Left Sidebar   */}
       <Box sx={{ width: '15%', minWidth: 200, borderRight: '1px solid #ddd', alignItems: 'left' }}>
         <LeftSideMenu
           items={[
             { name: 'Devices', link: '/app/device/ManageAppDevices', selected: false },
             { name: 'Push messages', link: '/app/device/ManageAppMessages', selected: false },
             { name: 'Chat', link: '/app/device/ManageAppChat', selected: false },
             { name: 'Content', link: '/app/device/ManageAppContent', selected: false },
             { name: 'Links', link: '/app/device/ManageAppLinks', selected: false },
             { name: 'Settings', link: '/app/device/AppSettings', selected: true },
           ]}
         />
       </Box>
        <Box sx={{ width: '85%' }}>
          <Box sx={{ p:{md: 5, xs: 2} }} >
            <FormGroup>
              <FormControlLabel control={<Checkbox />} label="Enable push" />
              <FormControlLabel control={<Checkbox />} label="Enable chat" />
              <FormControlLabel control={<Checkbox />} label="Enable content" />
              <FormControlLabel control={<Checkbox />} label="Enable links" />
              <FormControlLabel disabled control={<Checkbox />} label="Not avaliable" />
              <FormControlLabel required control={<Checkbox />} label="Required" />
            </FormGroup>
          </Box>
          <Box sx={{ m: 1, mt: 3, p: { xs: 1, md: 3 }, pt: 0}}>
            <ScrollableDataGrid
              height={300}
              rows={appSettings}
              columns={mainColumns ? highlightedGridColumns(mainColumns, searchText, apiRef) : []}
              loading={isLoading}
              onPageRequest={getPageAppDevices}
              checkboxSelection
              disableMultipleRowSelection
              onRowSelectionModelChange={(ids) => handleRowSelectionModelChange(ids)}
              onRowDoubleClick={(row) => handleRowDoubleClick(row)}
              rowSelectionModel={selectedIds}
              keepNonExistentRowsSelected={true}
            />
          </Box>
        </Box>
    </Box>
   </>
  )
}